const HouseIcon = ({ width = 20, height = 20, color = '#000000' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.17188 10.832V16.6654H15.8385V10.832"
        stroke={color}
        strokeWidth="1.66667"
        strokeLinecap="square"
      />
      <path
        d="M4.06711 2.4987H3.46212L3.27475 3.07395L2.61025 5.11406L2.60727 5.1232L2.60451 5.13241C2.57076 5.24475 2.54527 5.35939 2.52828 5.47547L2.52601 5.49098L2.52432 5.50657L2.51188 5.6217L2.50876 5.6505L2.50766 5.67944L2.50321 5.79582L2.50263 5.81108L2.50261 5.82636C2.50161 6.47623 2.76373 7.09224 3.21965 7.55249L3.81169 6.96603L3.21965 7.55249C3.67408 8.01123 4.28696 8.28242 4.931 8.3257C5.5749 8.36897 6.21882 8.18248 6.73331 7.79294C7.10484 7.51163 7.39099 7.13727 7.55844 6.71004C7.70251 7.07765 7.93505 7.40779 8.23665 7.67312C8.70631 8.08631 9.31231 8.31625 9.93767 8.33125C10.563 8.34624 11.1794 8.14569 11.6693 7.75687C12.0196 7.47886 12.2892 7.11662 12.4492 6.70612C12.4957 6.82363 12.5513 6.93769 12.6157 7.04729C12.7921 7.34769 13.0298 7.60723 13.3114 7.81219C13.5929 8.01707 13.9132 8.16375 14.2519 8.24564C14.5905 8.32753 14.9426 8.34348 15.2874 8.29284C15.6322 8.2422 15.9647 8.12565 16.2643 7.94828L15.8399 7.23116L16.2643 7.94828C16.5641 7.77086 16.8258 7.53554 17.0312 7.25424C17.2366 6.97278 17.3808 6.65173 17.452 6.3103C17.5232 5.96875 17.5192 5.61676 17.4404 5.2769L17.4377 5.26521L17.4346 5.2536L17.4124 5.16893L17.4069 5.14809L17.4004 5.12757L16.7479 3.07911L16.563 2.4987H15.9539H4.06711Z"
        stroke="black"
        strokeWidth="1.66667"
      />
    </svg>
  )
}

export default HouseIcon
